// extracted by mini-css-extract-plugin
module.exports = {"fileContainer":"PdfReader_fileContainer__1mWDr","pageInfo":"PdfReader_pageInfo__23RvN"};